import { render, staticRenderFns } from "./set_s_article.vue?vue&type=template&id=2612a20e&scoped=true&"
import script from "./set_s_article.vue?vue&type=script&lang=js&"
export * from "./set_s_article.vue?vue&type=script&lang=js&"
import style0 from "./set_s_article.vue?vue&type=style&index=0&id=2612a20e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2612a20e",
  null
  
)

export default component.exports